import { useEffect, useRef } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import s from "./UsefullLinks.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { getUsefullLinks } from "../../redux/InformationSlice";
import useWindowDimensions from "../../Components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../Components/MobileHeader/MobileHeader";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Seo } from "../../Seo";

const UsefullLinks = () => {
  const links = useSelector((state: RootState) => state.info.links);
  const dispatch: AppDispatch = useDispatch();
  const { width } = useWindowDimensions();
  const { t } = useTranslation();
  const linkTypeRu: Record<string, string> = {
    annual_report: t("Годовой отчет"),
    useful_info: t("Полезная информация"),
    external_partner: t("Внешний партнер"),
    catalog: t("Каталог"),
    partners: t("Партнеры"),
  };

  useEffect(() => {
    dispatch(getUsefullLinks());
  }, [dispatch]);

  const footerRef = useRef<HTMLDivElement | null>(null);
  const scrollToFooter = () => {
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <Seo
        title="Ссылки на сайты, законы в сфере ВИЧ"
        description="Ссылки на сайты, законы, официальные документы в сфере ВИЧ, сифилис, туберкулез, психоактивные вещества"
        url="https://www.vputi.org/links"
      />
      <div className={s.content}>
        {width > 1100 ? (
          <Header onContactsClick={scrollToFooter} />
        ) : (
          <MobileHeader onContactsClick={scrollToFooter} />
        )}
        <div className={s.title}>{t("ПОЛЕЗНЫЕ ССЫЛКИ")}</div>
        <div className={s.text}>
          {links &&
            [...links].reverse()?.map((it) => (
              <div className={s.link_item}>
                <div className={s.link_img}>
                  <img
                    className={s.link_icon}
                    src={
                      it.file_type === "adobe_pdf"
                        ? "/images/pdf.svg"
                        : it.file_type === "web_link"
                          ? "/images/link.svg"
                          : "/images/doc.svg"
                    }
                    alt=""
                  />
                </div>
                <div className={s.link_text}>
                  {/* <div className={s.category}>
                  {linkTypeRu[it.link_type] ?? it.link_type}
                </div> */}

                  {it.file_type === "adobe_pdf" ? (
                    <Link
                      to={it.file}
                      className={s.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {it.description}
                    </Link>
                  ) : (
                    <Link
                      to={it.url}
                      className={s.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {it.description}
                    </Link>
                  )}
                </div>
              </div>
            ))}
        </div>
      </div>
      <div ref={footerRef}>
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};

export default UsefullLinks;
